import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LazyLoadingComponent} from "../../../shared/component/lazy-loading/lazy-loading.component";
import {TranslocoDirective} from "@ngneat/transloco";
import {OnlineFirstComponent} from "../online-first/online-first.component";
import {RouterLink} from "@angular/router";
import {
    ArticleShortTemplateComponent
} from "../../../shared/component/article-short-template/article-short-template.component";
import {PageType} from "../../../shared/model/page-type";

@Component({
  selector: 'app-online-first-card-desktop',
  standalone: true,
  imports: [CommonModule, LazyLoadingComponent, TranslocoDirective, RouterLink, ArticleShortTemplateComponent],
  templateUrl: './online-first-card-desktop.component.html',
  styleUrl: './online-first-card-desktop.component.scss'
})
export class OnlineFirstCardDesktopComponent extends OnlineFirstComponent {

    protected readonly PageType = PageType;
}
